const prefixEvent = (event, timing) => {
	const el = document.createElement('el');

	const prefixes = ['webkit', 'moz', 'MS', 'o', ''];
	let events = {};

	for(let prefix of prefixes) {
		events[prefix + event] = prefix + event + timing;
	}

	for(let e in events) {
		if(typeof el.style[e] !== undefined) {
			return events[e];
		}
	}
}

export const BrowserEvents = {

	lazyload: 'lazyload.refresh',

	page: {
		enter: 'page.enter',
		leave: 'page.leave',
		transition: 'page.transition',
	},

	transition: {
		start: prefixEvent('Transition', 'Start'),
		end: prefixEvent('Transition', 'End'),
	},

	animation: {
		start: prefixEvent('Animation', 'Start'),
		end: prefixEvent('Animation', 'End'),
	}
};

export const MobileBreakpoint = 1024;

export const $Elements = {
	window: jQuery(window),
	document: jQuery(document),
	html: jQuery('html'),
	body: jQuery('body'),
	MainWrapper: jQuery('#main-wrapper')
}

export const Elements = {
	get HeaderWrapper() {
		return document.getElementById('header-wrapper');
	},
	get MenuWrapper() {
		return document.getElementById('menu-wrapper');
	},
	get MainWrapper() {
		return document.getElementById('main-wrapper');
	},
	get LoadingBar() {
		return document.querySelector('.loading-bar');
	},
};

export const Classes = {
	active: 'active',
	leaving: 'leaving',
	loading: 'loading',
	loaded: 'loaded',
	hidden: 'd-none',
	menuOpen: 'menu-open',
	menuLight: 'menu-light'
};
